// Lightweight non-invasive "ding" using the Web Audio API (no audio file needed).
// Plays a quick pleasant 3-note arpeggio at low volume.

let cachedContext: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (cachedContext) return cachedContext;
  const AudioCtor: typeof AudioContext | undefined =
    window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioCtor) return null;
  cachedContext = new AudioCtor();
  return cachedContext;
}

export function playCelebrationSound(): void {
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => undefined);
  }

  const notes = [659.25, 783.99, 1046.5]; // E5, G5, C6 — happy arpeggio
  const now = ctx.currentTime;
  const gap = 0.09;

  notes.forEach((freq, idx) => {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = 'triangle';
    oscillator.frequency.value = freq;

    const start = now + idx * gap;
    const stop = start + 0.18;
    // Soft envelope, low volume (0.08 peak)
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.08, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, stop);

    oscillator.connect(gain).connect(ctx.destination);
    oscillator.start(start);
    oscillator.stop(stop + 0.02);
  });
}
